import React from "react";
import {
  View,
  Image,
  Text,
  Platform,
  TouchableOpacity,
  useWindowDimensions,
} from "react-native";
import AppConstants, {
  isActionTabsLayout,
  isOpaqueStripeDisabled,
  NavigationScreenName,
  ScreenNameList,
} from "@lib/utilities/Constants";
import DeviceInfo from "react-native-device-info";
import Storage from "@lib/utilities/storage/StorageFunctions";
// APN badge context hook
import CommonStyle from "../../assets/styles/common-style";
import { styles, ids } from "./Style";
import {
  BACK_ICON,
  CROSS_ICON,
  NOTIFICAITON_ICON,
  PROFILE_ICON,
  LOGO_IMAGE,
  DOWNLOAD_ICON,
} from "../../resources/IMAGES";
import { labelText } from "../../resources/strings";
import { useAppSelector } from "@lib";

const NavigationBar = (props: any) => {
  const { width, height } = useWindowDimensions();
  // assign props variable
  let screenName = props.data.screenName;
  let displayName = props.data.displayName;
  let navigation = props.barNavigation;
  let downloadIndicator = props?.downloadIndicator;
  const { isConnected } = useAppSelector((state) => state.userReducer);

  // common function to navigate to inner screns ::
  const navigationToInnerScreens = async (
    _screenName: string,
    navigateTo: string,
  ) => {
    if (isConnected) {
      await Storage.clearData(
        AppConstants.LocalStoreConstant.IS_DATA_LOADED_ONCE,
      );
      await Storage.storeData(
        AppConstants.LocalStoreConstant.CURRENT_LOADED_SCREEN,
        _screenName,
      );
      navigation.navigate(navigateTo);
    } else {
      // props?.onNoInternet();
    }
  };

  // to navigate to policyActions / choosepolicy ::
  const navigateToPolicyActions = async (
    _screenName: string,
    navigateTo: string,
  ) => {
    await Storage.storeData(
      AppConstants.LocalStoreConstant.IS_COMING_FROM_NOTIFICATION,
      "no",
    );
    await Storage.clearData(
      AppConstants.LocalStoreConstant.IS_DATA_LOADED_ONCE,
    );
    await Storage.storeData(
      AppConstants.LocalStoreConstant.CURRENT_LOADED_SCREEN,
      _screenName,
    );
    navigation.navigate(navigateTo);
  };

  const onNotificationIconPress = () => {
    if (isConnected) {
      if (Platform.OS != "web") {
        Storage.clearData(AppConstants.LocalStoreConstant.BADGE_COUNT);
        props.onNotificationCenterPress();
      } else {
        props.onNotificationCenterPress();
      }
    } else {
      // props.onNoInternet();
    }
  };

  // to navigate to policyActions / choosepolicy ::
  const navBack = () => {
    navigation.goBack();
  };

  // TODO: Need to refator navigationn functions and move common code at one place

  const getNavigation1 = () => (
    <View
      style={[
        styles.navigationBar,
        {
          ...Platform.select({
            ios: { paddingVertical: 10, height: 110 },
          }),
        },
      ]}
      dataSet={{ media: ids.navigationBar }}
    >
      {!isOpaqueStripeDisabled && (
        <View style={[styles.bgEffect]} dataSet={{ media: ids.bgEffect }} />
      )}
      <View style={[styles.navContainer]} dataSet={{ media: ids.navContainer }}>
        <View
          style={[
            styles.navLeft,
            CommonStyle.styles.rowFlex,
            styles.marginLeft,
          ]}
          dataSet={{ media: ids.navLeft }}
        >
          <View style={styles.LogoCover} dataSet={{ media: ids.LogoCover }}>
            {Platform.OS == "web" ? (
              <Image
                style={styles.Logo}
                dataSet={{ media: ids.Logo }}
                source={LOGO_IMAGE}
                resizeMode={"contain"}
              />
            ) : (
              <Image
                style={styles.Logo}
                dataSet={{ media: ids.Logo }}
                source={LOGO_IMAGE}
              />
            )}
          </View>
        </View>
        <View style={[CommonStyle.styles.rowFlex, styles.navRightIcon]}>
          <View
            style={[CommonStyle.styles.rowFlex, styles.navRight]}
            dataSet={{ media: ids.navRight }}
          >
            <TouchableOpacity
              testID="header-notification-button"
              onPress={() => onNotificationIconPress()}
            >
              {Platform.OS == "web" ? (
                <Image
                  style={styles.bellIcon}
                  dataSet={{ media: ids.bellIcon }}
                  source={NOTIFICAITON_ICON}
                  testID={"header-notification-button-image"}
                  resizeMode={"contain"}
                />
              ) : (
                <Image
                  style={styles.bellIcon}
                  dataSet={{ media: ids.bellIcon }}
                  source={NOTIFICAITON_ICON}
                  testID={"header-notification-button-image"}
                />
              )}
            </TouchableOpacity>
          </View>
          <View
            style={[CommonStyle.styles.rowFlex, styles.navRight]}
            dataSet={{ media: ids.navRight }}
          >
            <TouchableOpacity
              testID="header-profile-button"
              onPress={() => props.onProfilePress()}
            >
              <Image
                style={styles.Profile}
                dataSet={{ media: ids.Profile }}
                source={PROFILE_ICON}
                testID={"header-profile-button-image"}
              />
            </TouchableOpacity>
          </View>
        </View>
      </View>
      <View></View>
    </View>
  );

  const getNavigation2 = () => (
    <View style={styles.navigationBar} dataSet={{ media: ids.navigationBar }}>
      {!isOpaqueStripeDisabled && (
        <View style={[styles.bgEffect]} dataSet={{ media: ids.bgEffect }} />
      )}
      <View
        style={styles.navContainer}
        dataSet={{ media: ids.navContainer }}
        testID="header-delete-account-container"
      >
        <Text
          style={[
            styles.navLogoText,
            CommonStyle.styles.rowFlex,
            styles.marginLeft,
            styles.leftText,
          ]}
          dataSet={{ media: ids.navLeft }}
          testID="header-delete-account-label"
        >
          Delete Account
        </Text>
        <View style={[CommonStyle.styles.rowFlex, styles.navRightIcon]}>
          <View
            style={[CommonStyle.styles.rowFlex, styles.navRight]}
            dataSet={{ media: ids.navRight }}
            testID="header-close-button-container"
          >
            <TouchableOpacity
              testID="header-close-button"
              onPress={() => navBack()}
            >
              <Image
                style={styles.deleteCross}
                dataSet={{ media: ids.deleteCross }}
                source={CROSS_ICON}
                testID="header-close-button-image"
              />
            </TouchableOpacity>
          </View>
        </View>
      </View>
      <View></View>
    </View>
  );

  const getNavigation3 = () => (
    <View style={styles.navigationBar} dataSet={{ media: ids.navigationBar }}>
      {!isOpaqueStripeDisabled && (
        <View style={[styles.bgEffect]} dataSet={{ media: ids.bgEffect }} />
      )}
      <View style={styles.navContainer} dataSet={{ media: ids.navContainer }}>
        <View
          style={[
            styles.navLeft,
            CommonStyle.styles.rowFlex,
            styles.marginLeft,
          ]}
          dataSet={{ media: ids.navLeft }}
        >
          <View style={styles.LogoCover} dataSet={{ media: ids.LogoCover }}>
            {Platform.OS == "web" ? (
              <Image
                style={styles.Logo}
                dataSet={{ media: ids.Logo }}
                source={LOGO_IMAGE}
                resizeMode={"contain"}
              />
            ) : (
              <Image
                style={styles.Logo}
                dataSet={{ media: ids.Logo }}
                source={LOGO_IMAGE}
              />
            )}
          </View>
        </View>
        <View style={[CommonStyle.styles.rowFlex, styles.navRightIcon]}>
          <View
            style={[CommonStyle.styles.rowFlex, styles.navRight]}
            dataSet={{ media: ids.navRight }}
          >
            <TouchableOpacity
              testID="header-profile-button"
              onPress={() => props.onProfilePress()}
            >
              <Image
                style={styles.Profile}
                dataSet={{ media: ids.Profile }}
                source={PROFILE_ICON}
                testID={"header-profile-button-image"}
              />
            </TouchableOpacity>
          </View>
        </View>
      </View>
      <View></View>
    </View>
  );

  const getNavigation4 = () => (
    <View style={styles.navigationBar} dataSet={{ media: ids.navigationBar }}>
      {!isOpaqueStripeDisabled && (
        <View style={[styles.bgEffect]} dataSet={{ media: ids.bgEffect }} />
      )}
      <View style={styles.navContainer} dataSet={{ media: ids.navContainer }}>
        <View
          style={[CommonStyle.styles.rowFlex, styles.navLeft]}
          dataSet={{ media: ids.navLeft }}
        >
          <View style={styles.LogoCover} dataSet={{ media: ids.LogoCover }}>
            {Platform.OS == "web" ? (
              <Image
                style={styles.Logo}
                dataSet={{ media: ids.Logo }}
                source={LOGO_IMAGE}
                resizeMode={"contain"}
              />
            ) : (
              <Image
                style={styles.Logo}
                dataSet={{ media: ids.Logo }}
                source={LOGO_IMAGE}
              />
            )}
          </View>
        </View>
        <View style={[CommonStyle.styles.rowFlex, styles.navRightIcon]}>
          <View
            style={[CommonStyle.styles.rowFlex, styles.navRight]}
            dataSet={{ media: ids.navRight }}
          >
            <TouchableOpacity
              testID="header-profile-button"
              onPress={() => props.onProfilePress()}
            >
              <Image
                style={styles.Profile}
                dataSet={{ media: ids.Profile }}
                source={PROFILE_ICON}
                testID={"header-profile-button-image"}
              />
            </TouchableOpacity>
          </View>
        </View>
      </View>
      <View></View>
    </View>
  );

  const getNavigation5 = () => (
    <View style={styles.navigationBar} dataSet={{ media: ids.navigationBar }}>
      {!isOpaqueStripeDisabled && (
        <View style={[styles.bgEffect]} dataSet={{ media: ids.bgEffect }} />
      )}
      <View style={[styles.navContainer]} dataSet={{ media: ids.navContainer }}>
        <View
          style={[CommonStyle.styles.rowFlex, styles.navLeft]}
          dataSet={{ media: ids.navLeft }}
        >
          <TouchableOpacity
            testID="header-back-button"
            onPress={() => {
              navBack();
            }}
            style={styles.BackArea}
          >
            <Image
              style={styles.Back}
              dataSet={{ media: ids.Back }}
              source={BACK_ICON}
            />
          </TouchableOpacity>
          <View style={styles.LogoCover} dataSet={{ media: ids.LogoCover }}>
            {Platform.OS == "web" ? (
              <Image
                style={styles.Logo}
                dataSet={{ media: ids.Logo }}
                source={LOGO_IMAGE}
                resizeMode={"contain"}
              />
            ) : (
              <Image
                style={styles.Logo}
                dataSet={{ media: ids.Logo }}
                source={LOGO_IMAGE}
              />
            )}
          </View>
        </View>
        <View style={[CommonStyle.styles.rowFlex, styles.navRightIcon]}>
          <View
            style={[CommonStyle.styles.rowFlex, styles.navRight]}
            dataSet={{ media: ids.navRight }}
          >
            <TouchableOpacity
              testID="header-profile-button"
              onPress={() => props.onProfilePress()}
            >
              <Image
                style={styles.Profile}
                dataSet={{ media: ids.Profile }}
                source={PROFILE_ICON}
                testID={"header-profile-button-image"}
              />
            </TouchableOpacity>
          </View>
        </View>
      </View>
      <View></View>
    </View>
  );

  const getNavigation6 = () => (
    <View style={[styles.navigationBar]} dataSet={{ media: ids.navigationBar }}>
      {!isOpaqueStripeDisabled && (
        <View style={[styles.bgEffect]} dataSet={{ media: ids.bgEffect }} />
      )}
      <View
        style={[styles.navContainer]}
        dataSet={{
          media: ids.navContainer,
        }}
      >
        <View
          style={[CommonStyle.styles.rowFlex, styles.navLeft]}
          dataSet={{ media: ids.navLeft }}
        >
          <TouchableOpacity
            testID="header-back-button"
            onPress={() =>
              navigateToPolicyActions(
                ScreenNameList.choosePolicy,
                NavigationScreenName.choosePolicy,
              )
            }
            style={styles.BackArea}
          >
            <Image
              style={styles.Back}
              dataSet={{ media: ids.Back }}
              source={BACK_ICON}
            />
          </TouchableOpacity>
          <View style={styles.LogoCover} dataSet={{ media: ids.LogoCover }}>
            {Platform.OS == "web" ? (
              <Image
                style={styles.Logo}
                dataSet={{ media: ids.Logo }}
                source={LOGO_IMAGE}
                resizeMode={"contain"}
              />
            ) : (
              <Image
                style={styles.Logo}
                dataSet={{ media: ids.Logo }}
                source={LOGO_IMAGE}
              />
            )}
          </View>
        </View>
        <View style={[styles.mainLink]} dataSet={{ media: ids.mainLink }}>
          <View
            style={[CommonStyle.styles.rowFlex, styles.navList]}
            dataSet={{ media: ids.navList }}
          >
            <TouchableOpacity
              onPress={() =>
                navigationToInnerScreens(
                  ScreenNameList.billingPayments,
                  NavigationScreenName.billingPayments,
                )
              }
              testID="header-billing-nav"
            >
              <Text style={styles.navText} dataSet={{ media: ids.navText }}>
                {labelText.button.billing}
              </Text>
            </TouchableOpacity>
            <TouchableOpacity
              onPress={() =>
                navigationToInnerScreens(
                  ScreenNameList.documentInfo,
                  NavigationScreenName.documentInfo,
                )
              }
              testID="header-docs-nav"
            >
              <Text style={styles.navText} dataSet={{ media: ids.navText }}>
                {labelText.button.docs}
              </Text>
            </TouchableOpacity>
            <TouchableOpacity
              onPress={() =>
                navigationToInnerScreens(
                  ScreenNameList.makeClaim,
                  NavigationScreenName.makeClaim,
                )
              }
              testID="header-claims-nav"
            >
              <Text style={styles.navText} dataSet={{ media: ids.navText }}>
                {labelText.button.claims}
              </Text>
            </TouchableOpacity>
            <TouchableOpacity
              onPress={() =>
                navigationToInnerScreens(
                  ScreenNameList.contactAgent,
                  NavigationScreenName.contactAgent,
                )
              }
              testID="header-agent-nav"
            >
              <Text style={styles.navText} dataSet={{ media: ids.navText }}>
                {labelText.button.agent}
              </Text>
            </TouchableOpacity>
          </View>
        </View>
        <View style={[CommonStyle.styles.rowFlex, styles.navRightIcon]}>
          <View
            style={[CommonStyle.styles.rowFlex, styles.navRight]}
            dataSet={{ media: ids.navRight }}
          >
            <TouchableOpacity
              testID="header-notification-button"
              onPress={() => onNotificationIconPress()}
            >
              {Platform.OS == "web" ? (
                <Image
                  style={styles.bellIcon}
                  dataSet={{ media: ids.bellIcon }}
                  source={NOTIFICAITON_ICON}
                  testID={"header-notification-button-image"}
                  resizeMode={"contain"}
                />
              ) : (
                <Image
                  style={styles.bellIcon}
                  dataSet={{ media: ids.bellIcon }}
                  source={NOTIFICAITON_ICON}
                  testID={"header-notification-button-image"}
                />
              )}
            </TouchableOpacity>
          </View>
          <View
            style={[CommonStyle.styles.rowFlex, styles.navRight]}
            dataSet={{ media: ids.navRight }}
          >
            <TouchableOpacity
              testID="header-profile-button"
              onPress={() => props.onProfilePress()}
            >
              <Image
                style={styles.Profile}
                dataSet={{ media: ids.Profile }}
                source={PROFILE_ICON}
                testID={"header-profile-button-image"}
              />
            </TouchableOpacity>
          </View>
        </View>
      </View>
      <View></View>
    </View>
  );
  const getNavigation7 = () => (
    <View style={[styles.navigationBar]} dataSet={{ media: ids.navigationBar }}>
      {!isOpaqueStripeDisabled && (
        <View style={[styles.bgEffect]} dataSet={{ media: ids.bgEffect }} />
      )}
      <View
        style={
          isActionTabsLayout()
            ? styles.navContainerPolicyAction
            : styles.navContainer
        }
        dataSet={{
          media: isActionTabsLayout()
            ? ids?.navContainerPolicyAction
            : ids.navContainer,
        }}
      >
        <View
          style={[CommonStyle.styles.rowFlex, styles.navLeft]}
          dataSet={{ media: ids.navLeft }}
        >
          <TouchableOpacity
            testID="header-back-button"
            onPress={() =>
              navigateToPolicyActions(
                ScreenNameList.choosePolicy,
                NavigationScreenName.choosePolicy,
              )
            }
            style={styles.BackArea}
          >
            <Image
              style={styles.Back}
              dataSet={{ media: ids.Back }}
              source={BACK_ICON}
            />
          </TouchableOpacity>
          <View style={styles.LogoCover} dataSet={{ media: ids.LogoCover }}>
            {Platform.OS == "web" ? (
              <Image
                style={styles.Logo}
                dataSet={{ media: ids.Logo }}
                source={LOGO_IMAGE}
                resizeMode={"contain"}
              />
            ) : (
              <Image
                style={styles.Logo}
                dataSet={{ media: ids.Logo }}
                source={LOGO_IMAGE}
              />
            )}
          </View>
        </View>
        <View style={[CommonStyle.styles.rowFlex, styles.navRightIcon]}>
          <View
            style={[CommonStyle.styles.rowFlex, styles.navRight]}
            dataSet={{ media: ids.navRight }}
          >
            <TouchableOpacity
              testID="header-notification-button"
              onPress={() => onNotificationIconPress()}
            >
              {Platform.OS == "web" ? (
                <Image
                  style={styles.bellIcon}
                  dataSet={{ media: ids.bellIcon }}
                  source={NOTIFICAITON_ICON}
                  testID={"header-notification-button-image"}
                  resizeMode={"contain"}
                />
              ) : (
                <Image
                  style={styles.bellIcon}
                  dataSet={{ media: ids.bellIcon }}
                  source={NOTIFICAITON_ICON}
                  testID={"header-notification-button-image"}
                />
              )}
            </TouchableOpacity>
          </View>
          <View
            style={[CommonStyle.styles.rowFlex, styles.navRight]}
            dataSet={{ media: ids.navRight }}
          >
            <TouchableOpacity
              testID="header-profile-button"
              onPress={() => props.onProfilePress()}
            >
              <Image
                style={styles.Profile}
                dataSet={{ media: ids.Profile }}
                source={PROFILE_ICON}
                testID={"header-profile-button-image"}
              />
            </TouchableOpacity>
          </View>
        </View>
      </View>
      <View></View>
    </View>
  );
  const getNavigation8 = () => (
    <View style={styles.navigationBar} dataSet={{ media: ids.navigationBar }}>
      {!isOpaqueStripeDisabled && (
        <View style={[styles.bgEffect]} dataSet={{ media: ids.bgEffect }} />
      )}
      <View style={[styles.navContainer]} dataSet={{ media: ids.navContainer }}>
        <View
          style={[CommonStyle.styles.rowFlex, styles.navLeft]}
          dataSet={{ media: ids.navLeft }}
        >
          <TouchableOpacity
            testID="header-back-button"
            onPress={() =>
              navigateToPolicyActions(
                ScreenNameList.policyActions,
                NavigationScreenName.policyActions,
              )
            }
            style={styles.BackArea}
          >
            <Image
              style={styles.Back}
              dataSet={{ media: ids.Back }}
              source={BACK_ICON}
            />
          </TouchableOpacity>
          <View style={styles.LogoCover} dataSet={{ media: ids.LogoCover }}>
            {Platform.OS == "web" ? (
              <Image
                style={styles.Logo}
                dataSet={{ media: ids.Logo }}
                source={LOGO_IMAGE}
                resizeMode={"contain"}
              />
            ) : (
              <Image
                style={styles.Logo}
                dataSet={{ media: ids.Logo }}
                source={LOGO_IMAGE}
              />
            )}
          </View>
        </View>
        <View style={[styles.mainLink]} dataSet={{ media: ids.mainLink }}>
          <View
            style={[
              CommonStyle.styles.rowFlex,
              styles.navList,
              {
                ...Platform.select({
                  android: {
                    width: height > width ? width * 0.5 : width * 0.7,
                    justifyContent: "space-evenly",
                  },
                }),
              },
            ]}
            dataSet={{ media: ids.navList }}
          >
            {screenName == ScreenNameList.billingPayments ? (
              <TouchableOpacity
                onPress={() =>
                  navigationToInnerScreens(
                    ScreenNameList.billingPayments,
                    NavigationScreenName.billingPayments,
                  )
                }
                style={CommonStyle.styles.inMiddle}
                testID="header-billing-nav"
              >
                <Text
                  style={[styles.navText, styles.activeDocs]}
                  dataSet={{ media: ids.activeDocs }}
                >
                  {labelText.button.billing}
                </Text>
                <View
                  style={styles.navActiveDocs}
                  dataSet={{ media: ids.navActiveDocs }}
                />
              </TouchableOpacity>
            ) : (
              <TouchableOpacity
                onPress={() =>
                  navigationToInnerScreens(
                    ScreenNameList.billingPayments,
                    NavigationScreenName.billingPayments,
                  )
                }
                testID="header-billing-nav"
              >
                <Text style={[styles.navText]} dataSet={{ media: ids.navText }}>
                  {labelText.button.billing}
                </Text>
              </TouchableOpacity>
            )}
            {screenName == ScreenNameList.documentInfo ? (
              <TouchableOpacity
                onPress={() =>
                  navigationToInnerScreens(
                    ScreenNameList.documentInfo,
                    NavigationScreenName.documentInfo,
                  )
                }
                style={CommonStyle.styles.inMiddle}
                testID="header-docs-nav"
              >
                <Text
                  dataSet={{ media: ids.activeDocs }}
                  style={[styles.navText, styles.activeDocs]}
                >
                  {labelText.button.docs}
                </Text>
                <View
                  style={styles.navActiveDocs}
                  dataSet={{ media: ids.navActiveDocs }}
                />
              </TouchableOpacity>
            ) : (
              <TouchableOpacity
                onPress={() =>
                  navigationToInnerScreens(
                    ScreenNameList.documentInfo,
                    NavigationScreenName.documentInfo,
                  )
                }
                testID="header-docs-nav"
              >
                <Text style={styles.navText} dataSet={{ media: ids.navText }}>
                  {labelText.button.docs}
                </Text>
              </TouchableOpacity>
            )}
            {screenName == ScreenNameList.makeClaim ? (
              <TouchableOpacity
                onPress={() =>
                  navigationToInnerScreens(
                    ScreenNameList.makeClaim,
                    NavigationScreenName.makeClaim,
                  )
                }
                style={CommonStyle.styles.inMiddle}
                testID="header-claims-nav"
              >
                <Text
                  dataSet={{ media: ids.activeClaim }}
                  style={[styles.navText, styles.activeClaim]}
                >
                  {labelText.button.claims}
                </Text>
                <View
                  style={styles.navActiveClaim}
                  dataSet={{ media: ids.navActiveClaim }}
                />
              </TouchableOpacity>
            ) : (
              <TouchableOpacity
                onPress={() =>
                  navigationToInnerScreens(
                    ScreenNameList.makeClaim,
                    NavigationScreenName.makeClaim,
                  )
                }
                testID="header-claims-nav"
              >
                <Text style={styles.navText} dataSet={{ media: ids.navText }}>
                  Claims
                </Text>
              </TouchableOpacity>
            )}
            {screenName == ScreenNameList.contactAgent ? (
              <TouchableOpacity
                onPress={() =>
                  navigationToInnerScreens(
                    ScreenNameList.contactAgent,
                    NavigationScreenName.contactAgent,
                  )
                }
                style={CommonStyle.styles.inMiddle}
                testID="header-agent-nav"
              >
                <Text
                  dataSet={{ media: ids.activeAgent }}
                  style={[styles.navText, styles.activeAgent]}
                >
                  Agent
                </Text>
                <View
                  style={styles.navActiveAgent}
                  dataSet={{ media: ids.navActiveAgent }}
                />
              </TouchableOpacity>
            ) : (
              <TouchableOpacity
                onPress={() =>
                  navigationToInnerScreens(
                    ScreenNameList.contactAgent,
                    NavigationScreenName.contactAgent,
                  )
                }
                testID="header-agent-nav"
              >
                <Text style={styles.navText} dataSet={{ media: ids.navText }}>
                  Agent
                </Text>
              </TouchableOpacity>
            )}
          </View>
        </View>
        <View style={[CommonStyle.styles.rowFlex, styles.navRightIcon]}>
          <View
            style={[CommonStyle.styles.rowFlex, styles.navRight]}
            dataSet={{ media: ids.navRight }}
          >
            <TouchableOpacity
              testID="header-notification-button"
              onPress={() => onNotificationIconPress()}
            >
              {Platform.OS == "web" ? (
                <Image
                  style={styles.bellIcon}
                  dataSet={{ media: ids.bellIcon }}
                  source={NOTIFICAITON_ICON}
                  testID={"header-notification-button-image"}
                  resizeMode={"contain"}
                />
              ) : (
                <Image
                  style={styles.bellIcon}
                  dataSet={{ media: ids.bellIcon }}
                  source={NOTIFICAITON_ICON}
                  testID={"header-notification-button-image"}
                />
              )}
            </TouchableOpacity>
          </View>
          <View
            style={[CommonStyle.styles.rowFlex, styles.navRight]}
            dataSet={{ media: ids.navRight }}
          >
            <TouchableOpacity
              testID="header-profile-button"
              onPress={() => props.onProfilePress()}
            >
              <Image
                style={styles.Profile}
                dataSet={{ media: ids.Profile }}
                source={PROFILE_ICON}
                testID={"header-profile-button-image"}
              />
            </TouchableOpacity>
          </View>
        </View>
      </View>
      <View></View>
    </View>
  );
  const getNavigation9 = () => (
    <View style={styles.navigationBar} dataSet={{ media: ids.navigationBar }}>
      {!isOpaqueStripeDisabled && (
        <View style={[styles.bgEffect]} dataSet={{ media: ids.bgEffect }} />
      )}
      <View style={styles.navContainer} dataSet={{ media: ids.navContainer }}>
        <View
          style={[CommonStyle.styles.rowFlex, styles.navLeft]}
          dataSet={{ media: ids.navLeft }}
        >
          <TouchableOpacity
            testID="header-back-button"
            onPress={() =>
              navigateToPolicyActions(
                ScreenNameList.policyActions,
                NavigationScreenName.policyActions,
              )
            }
            style={styles.BackArea}
          >
            <Image
              style={styles.Back}
              dataSet={{ media: ids.Back }}
              source={BACK_ICON}
            />
          </TouchableOpacity>
        </View>
        <View style={[CommonStyle.styles.rowFlex]}>
          <View style={[CommonStyle.styles.rowFlex]}>
            <Text
              style={styles.navLogoText}
              dataSet={{ media: ids.navLogoText }}
            >
              {screenName}
            </Text>
          </View>
        </View>
        <View style={[CommonStyle.styles.rowFlex, styles.navRightIcon]}>
          <View
            style={[CommonStyle.styles.rowFlex, styles.navRight]}
            dataSet={{ media: ids.navRight }}
          >
            <TouchableOpacity
              testID="header-notification-button"
              onPress={() => onNotificationIconPress()}
            >
              {Platform.OS == "web" ? (
                <Image
                  style={styles.bellIcon}
                  dataSet={{ media: ids.bellIcon }}
                  source={NOTIFICAITON_ICON}
                  testID={"header-notification-button-image"}
                  resizeMode={"contain"}
                />
              ) : (
                <Image
                  style={styles.bellIcon}
                  dataSet={{ media: ids.bellIcon }}
                  source={NOTIFICAITON_ICON}
                  testID={"header-notification-button-image"}
                />
              )}
            </TouchableOpacity>
          </View>
          <View
            style={[CommonStyle.styles.rowFlex, styles.navRight]}
            dataSet={{ media: ids.navRight }}
          >
            <TouchableOpacity
              testID="header-profile-button"
              onPress={() => props.onProfilePress()}
            >
              <Image
                style={styles.Profile}
                dataSet={{ media: ids.Profile }}
                source={PROFILE_ICON}
                testID={"header-profile-button-image"}
              />
            </TouchableOpacity>
          </View>
        </View>
      </View>
      <View></View>
    </View>
  );
  const getNavigation10 = () => (
    <View
      style={[
        styles.navigationBar,
        {
          ...Platform.select({
            ios: { paddingTop: 30, paddingBottom: 10, height: 110 },
          }),
        },
      ]}
      dataSet={{ media: ids.navigationBar }}
    >
      {!isOpaqueStripeDisabled && (
        <View style={[styles.bgEffect]} dataSet={{ media: ids.bgEffect }} />
      )}
      <View
        style={[styles.navContainer, styles.navContainerPdf]}
        dataSet={{ media: ids.navContainer }}
      >
        <View
          style={[CommonStyle.styles.rowFlex, styles.navLeft]}
          dataSet={{ media: ids.navLeft }}
        >
          <TouchableOpacity
            testID="header-back-button"
            onPress={() => props.barNavigation.goBack()}
            style={styles.BackArea}
          >
            <Image
              style={styles.Back}
              dataSet={{ media: ids.Back }}
              source={BACK_ICON}
            />
          </TouchableOpacity>
        </View>
        <View
          style={[
            CommonStyle.styles.rowFlex,
            { justifyContent: "center", alignItems: "center" },
          ]}
        >
          <Text
            numberOfLines={3}
            style={styles.navDisplayText}
            dataSet={{ media: ids.navDisplayText }}
          >
            {displayName}
          </Text>
        </View>
        <View
          style={[CommonStyle.styles.rowFlex, styles.navRight]}
          dataSet={{ media: ids.navRight }}
        >
          <TouchableOpacity
            testID="profileBtn"
            onPress={() => props?.onDownloadPress()}
            disabled={downloadIndicator}
            style={[downloadIndicator && { opacity: 0.2 }]}
          >
            <Image
              style={styles.Profile}
              dataSet={{ media: ids.Profile }}
              source={DOWNLOAD_ICON}
            />
          </TouchableOpacity>
        </View>
      </View>
    </View>
  );
  const isNavigationScreen = (name: string) =>
    name == ScreenNameList.makeClaim ||
    name == ScreenNameList.makePayment ||
    name == ScreenNameList.documentInfo ||
    name == ScreenNameList.contactAgent ||
    name == ScreenNameList.billingPayments;

  const navigationMap = {
    [ScreenNameList.login]: getNavigation1,
    [ScreenNameList.choosePolicy]: getNavigation1,
    [ScreenNameList.deleteAccount]: getNavigation2,
    [ScreenNameList.regsiterSuccessView]: getNavigation3,
    [ScreenNameList.forgotPassword]:
      Platform.OS === "web" ? getNavigation4 : getNavigation5,
    [ScreenNameList.resetPassword]: getNavigation5,
    [ScreenNameList.policyActions]:
      Platform.OS === "web" && !isActionTabsLayout()
        ? getNavigation6
        : getNavigation7,
    [ScreenNameList.pdfViewer]:
      Platform.OS !== "web" ? getNavigation10 : undefined,
  };
  const getActiveStyle = (screenName: string) => {
    switch (screenName) {
      case ScreenNameList.billingPayments:
        return styles.activeDocs;
      case ScreenNameList.documentInfo:
        return styles.activeDocs;
      case ScreenNameList.makeClaim:
        return styles.activeClaim;
      case ScreenNameList.contactAgent:
        return styles.activeAgent;
      default:
        return null;
    }
  };

  const getIndicatorStyle = (screenName: string) => {
    switch (screenName) {
      case ScreenNameList.billingPayments:
        return styles.navActiveDocs;
      case ScreenNameList.documentInfo:
        return styles.navActiveDocs;
      case ScreenNameList.makeClaim:
        return styles.navActiveClaim;
      case ScreenNameList.contactAgent:
        return styles.navActiveAgent;
      default:
        return null;
    }
  };
  const navigationItems = [
    {
      navScreenName: ScreenNameList.billingPayments,
      navigationScreen: NavigationScreenName.billingPayments,
      label: "Billing",
    },
    {
      navScreenName: ScreenNameList.documentInfo,
      navigationScreen: NavigationScreenName.documentInfo,
      label: "Docs",
    },
    {
      navScreenName: ScreenNameList.makeClaim,
      navigationScreen: NavigationScreenName.makeClaim,
      label: "Claims",
    },
    {
      navScreenName: ScreenNameList.contactAgent,
      navigationScreen: NavigationScreenName.contactAgent,
      label: "Agent",
    },
  ];

  const renderNavItem = ({
    navScreenName,
    label,
    navigationScreen,
  }: {
    navigationScreen: string;
    navScreenName: string;
    label: string;
  }) => {
    return (
      <>
        {screenName == navScreenName ? (
          <TouchableOpacity
            onPress={() =>
              navigationToInnerScreens(screenName, navigationScreen)
            }
            style={CommonStyle.styles.inMiddle}
          >
            <Text
              style={[styles.navText, getActiveStyle(screenName)]}
              dataSet={{ media: ids.activeAgent }}
            >
              {label}
            </Text>
            <View
              style={{ ...getIndicatorStyle(screenName) }}
              dataSet={{ media: ids.navActiveAgent }}
            />
          </TouchableOpacity>
        ) : (
          <TouchableOpacity
            onPress={() =>
              navigationToInnerScreens(screenName, navigationScreen)
            }
          >
            <Text style={styles.navText} dataSet={{ media: ids.navText }}>
              {label}
            </Text>
          </TouchableOpacity>
        )}
      </>
    );
  };

  const getNavigationTab = () => (
    <View
      style={[styles.navigationBar, { paddingBottom: 10 }]}
      dataSet={{ media: ids.navigationBar }}
    >
      {!isOpaqueStripeDisabled && (
        <View style={[styles.bgEffect]} dataSet={{ media: ids.bgEffect }} />
      )}
      <View style={[styles.navContainer]} dataSet={{ media: ids.navContainer }}>
        <View
          style={{
            flexDirection: "row",
            justifyContent: "flex-start",
            alignItems: "center",
            flex: 1,
            paddingHorizontal: "3%",
            paddingBottom: Platform.OS == "ios" ? "1%" : 0,
          }}
          dataSet={{}}
        >
          <TouchableOpacity
            testID="header-back-button"
            onPress={() =>
              navigateToPolicyActions(
                ScreenNameList.policyActions,
                NavigationScreenName.policyActions,
              )
            }
            style={{
              padding: 10,
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Image
              style={styles.Back}
              dataSet={{ media: ids.Back }}
              source={BACK_ICON}
            />
          </TouchableOpacity>
          <View
            style={{
              flex: 1,
              marginLeft: 15,
              // marginBottom: Platform.OS == "android" ? 5 : 0,
            }}
            dataSet={{ media: ids.LogoCover }}
          >
            <Image
              style={{
                width: Platform.OS == "android" ? 100 : 110,
                height: "100%",
                display: "flex",
                resizeMode: "contain",
              }}
              source={LOGO_IMAGE}
            />
          </View>
        </View>
        <View
          style={{
            flex: 3,
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
          }}
          dataSet={{}}
        >
          <View
            style={[
              {
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
                flex: 1,
              },
            ]}
          >
            <>{navigationItems.map((item) => renderNavItem(item))}</>
          </View>
        </View>
        <View
          style={{
            marginLeft: "5%",
            flexDirection: "row",
            justifyContent: "flex-end",
            alignItems: "center",
          }}
        >
          <View
            style={[CommonStyle.styles.rowFlex, styles.navRight]}
            dataSet={{ media: ids.navRight }}
          >
            <TouchableOpacity
              testID="header-notification-button"
              onPress={() => onNotificationIconPress()}
            >
              {Platform.OS == "web" ? (
                <Image
                  style={styles.bellIcon}
                  dataSet={{ media: ids.bellIcon }}
                  source={NOTIFICAITON_ICON}
                  testID={"header-notification-button-image"}
                  resizeMode={"contain"}
                />
              ) : (
                <Image
                  style={styles.bellIcon}
                  dataSet={{ media: ids.bellIcon }}
                  source={NOTIFICAITON_ICON}
                  testID={"header-notification-button-image"}
                />
              )}
            </TouchableOpacity>
          </View>
          <View
            style={[CommonStyle.styles.rowFlex, styles.navRight]}
            dataSet={{ media: ids.navRight }}
          >
            <TouchableOpacity
              testID="header-profile-button"
              onPress={() => props.onProfilePress()}
            >
              <Image
                style={styles.Profile}
                dataSet={{ media: ids.Profile }}
                source={PROFILE_ICON}
                testID={"header-profile-button-image"}
              />
            </TouchableOpacity>
          </View>
        </View>
      </View>
      <View></View>
    </View>
  );

  return (
    <View>
      {(() => {
        const navFunction = navigationMap[screenName];
        if (navFunction) {
          return navFunction();
        }

        if (isNavigationScreen(screenName)) {
          if (DeviceInfo.isTablet()) {
            return getNavigationTab();
          }
          if (Platform.OS === "web") {
            return getNavigation8();
          } else if (!DeviceInfo.isTablet()) {
            return getNavigation9();
          }
        }
      })()}
    </View>
  );
};

export default NavigationBar;
